// extracted by mini-css-extract-plugin
export default {"titlebar":"Titlebar_titlebar__+4gNV"};